import { store } from "../../../redux/store";
import {
  sessionPaymentSuccess,
  sessionPaymentFailure,
  createBooking,
} from "../../../redux/actions/mindfulness";
import { handleErrorMessage } from "../../../redux/actions/groups";


export const loadRazorpayScript = (src = "https://checkout.razorpay.com/v1/checkout.js") => {
  console.log("Loading Razorpay SDK");
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
};


export const openRazorpayPayment = async ({
  sessionPaymentOrder,
  amount,
  session,
  selectedSlot,
  selectedSessionType,
  dispatch,
  onSuccess,
  onFailure,
  onDismiss,
  setIsLoadingBtn,
}) => {
  console.log("Opening Razorpay payment gateway");
  
  const isScriptLoaded = await loadRazorpayScript();

  if (!isScriptLoaded) {
    handleErrorMessage("Razorpay SDK failed to load. Are you online?");
    setIsLoadingBtn(false);
    return;
  }

  console.log(
    "Razorpay SDK loaded successfully",
    sessionPaymentOrder,
  );

  let isProcessingFailure = false;

  // Configure Razorpay options
  const options = {
    key: `${process.env.REACT_APP_RAZORPAY_KEY}`,
    amount: amount * 100, // Convert to paise
    name:
      sessionPaymentOrder?.options_name ??
      store?.getState().mindfulness?.sessionPaymentOrder?.options_name,
    description:
      sessionPaymentOrder?.options_description ??
      store?.getState().mindfulness?.sessionPaymentOrder?.options_description,
    order_id:
      sessionPaymentOrder?.options_order_id ??
      store?.getState().mindfulness?.sessionPaymentOrder?.options_order_id,
    image:
      sessionPaymentOrder?.options_image ??
      store?.getState().mindfulness?.sessionPaymentOrder?.options_image,
    currency: "INR",
    handler: async (response) => {
      const paymentData = {
        razorpay_signature: response.razorpay_signature,
        razorpay_order_id: response.razorpay_order_id,
        razorpay_payment_id: response.razorpay_payment_id,
      };

      console.log("Payment successful", paymentData);

      await dispatch(sessionPaymentSuccess(paymentData));

      // Create booking after successful payment
      const bookingPayload = {
        creator_session: session.id,
        start_time: selectedSlot,
        duration: session.duration,
        type: selectedSessionType,
      };

      console.log("Creating booking", bookingPayload);
      await dispatch(createBooking(bookingPayload));

      setIsLoadingBtn(false);

      if (onSuccess) {
        onSuccess();
      }
    },
    prefill: {
      name:
        sessionPaymentOrder?.prefill_name ??
        store?.getState().mindfulness?.sessionPaymentOrder?.prefill_name,
      email:
        sessionPaymentOrder?.prefill_email ??
        store?.getState().mindfulness?.sessionPaymentOrder?.prefill_email,
    },
    notes: {
      address:
        sessionPaymentOrder?.notes_address ??
        store?.getState().mindfulness?.sessionPaymentOrder?.notes_address,
    },
    theme: {
      color: "#ED1E24",
    },
    retry: false,
    modal: {
      ondismiss: () => {
        console.log("Payment modal dismissed");
        
        if (!isProcessingFailure) {
          setIsLoadingBtn(false);
          if (onDismiss) {
            onDismiss();
          }
        }
      },
    },
  };

  // Create Razorpay instance
  const paymentObject = new window.Razorpay(options);

  // Handle payment failure
  paymentObject.on("payment.failed", async (response) => {
    isProcessingFailure = true;
    
    const failureData = {
      order_id: response?.error?.metadata?.order_id,
      payment_id: response?.error?.metadata?.payment_id,
      code: response?.error?.code,
      description: response?.error?.description,
      reason: response?.error?.reason,
      step: response?.error?.step,
      source: response?.error?.source,
    };

    console.log("Payment failed", failureData);

    await dispatch(sessionPaymentFailure(failureData));

    if (onFailure) {
      await onFailure(failureData);
    }
    
    setIsLoadingBtn(false);
  });

  paymentObject.open();
};


export const handleSessionPayment = async ({
  session,
  selectedSessionType,
  selectedSlot,
  amount,
  sessionPaymentOrder,
  dispatch,
  createSessionPayment,
  onSuccess,
  onFailure,
  onDismiss,
  setIsLoadingBtn,
}) => {
  setIsLoadingBtn(true);

  // Create payment order
  const paymentData = {
    currency: "INR",
    service: "mindfulness",
    product_id: session.id,
    creator_session_type: selectedSessionType,
  };

  console.log("Creating payment order with data:", paymentData);
  const result = await dispatch(createSessionPayment(paymentData));

  if (result.success) {
    // Open Razorpay after payment order is created
    await openRazorpayPayment({
      sessionPaymentOrder:
        result.data?.data || store?.getState().mindfulness?.sessionPaymentOrder,
      amount,
      session,
      selectedSlot,
      selectedSessionType,
      dispatch,
      onSuccess,
      onFailure,
      onDismiss,
      setIsLoadingBtn,
    });
  } else {
    setIsLoadingBtn(false);
    console.error("Failed to create payment order");
    handleErrorMessage("Failed to initiate payment. Please try again.");
  }
};
